import React from 'react';
import {useControllerProps} from '../../ControllerContext';
import {ShippingSectionText} from './ShippingSectionText';
import settingsParams from '../../../settingsParams';
import {useLocaleKeys} from '../../../LocaleKeysProvider';
import {useSettingsWithDefaults} from '../../../../../hooks/useSettingsWithDefaults';
import {PaymentMethodName} from '../../../../../types/app.types';
import {LocaleKeys} from '../../../../../locale-keys/LocaleKeys';

export enum PaymentMethodSectionDataHook {
  root = 'PaymentMethodSectionDataHook.root',
  title = 'PaymentMethodSectionDataHook.title',
  content = 'PaymentMethodSectionDataHook.content',
}

const translatePaymentMethodName = (
  name: PaymentMethodName,
  localeKeys: LocaleKeys,
  supportMultipleGCInTYP: boolean
): string => {
  if (name.type !== 'giftCard') {
    return name.value;
  }
  return name.obfuscatedCode && supportMultipleGCInTYP
    ? localeKeys.thankYouPage.giftCard.labelWithCode({obfuscationCode: name.obfuscatedCode})
    : localeKeys.thankYouPage.giftCard.label();
};

export const PaymentMethodsColumn = () => {
  const {getSettingsWithDefaults} = useSettingsWithDefaults();
  const localeKeys = useLocaleKeys();
  const {paymentMethodNames, supportMultipleGCInTYP} = useControllerProps().thankYouPageStore;

  const paymentMethods = paymentMethodNames
    .map((name) => translatePaymentMethodName(name, localeKeys, supportMultipleGCInTYP))
    .filter((name) => name !== 'N/A');
  if (!paymentMethods.length) {
    return null;
  }

  const hasMultipleMethods = paymentMethods.length > 1;
  const shouldStackMethods = supportMultipleGCInTYP && hasMultipleMethods;

  return (
    <div data-hook={PaymentMethodSectionDataHook.root}>
      <ShippingSectionText
        dataHook={PaymentMethodSectionDataHook.title}
        // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
        text={getSettingsWithDefaults(settingsParams.THANK_YOU_PAGE_PAYMENT_METHOD_LABEL)}
        isTitle={true}
      />
      {shouldStackMethods ? (
        paymentMethods.map((method, index) => (
          <ShippingSectionText key={index} dataHook={PaymentMethodSectionDataHook.content} text={method} />
        ))
      ) : (
        <ShippingSectionText
          dataHook={PaymentMethodSectionDataHook.content}
          text={
            hasMultipleMethods
              ? localeKeys.thankYouPage.paymentMethod.multipleMethods.label({
                  paymentMethod1: paymentMethods[0],
                  paymentMethod2: paymentMethods[1],
                })
              : paymentMethods[0]
          }
        />
      )}
    </div>
  );
};
